/** This could be avoided if the backend would send HTML conform constraints */
import { isNotNullOrUndefined } from '../../../lib/typeGuards';
import { IParameterProperty } from '../../../types/IParameter';

const normalizeConstraint = (constraint: string): string | null => {
  switch (constraint) {
    case 'maxFileSizeInBytes':
      return 'size';
    case 'fileExtensions':
    case 'maxRequestSizeInBytes':
    case 'mimeTypes':
    case 'minFileSizeInBytes':
    case 'minHeight':
    case 'maxHeight':
    case 'minWidth':
    case 'maxWidth':
    case 'aspectRatio':
    case 'possibleMinSizes':
      return null;
    default:
      return constraint;
  }
};

/**
 * Returns sanitized validation rules from the backend for HTML elements
 *
 * Supported valudation rules (by react-hook-form):
 * - required
 * - min
 * - max
 * - minLength
 * - maxLength
 * - pattern
 * - validate
 */
export const getConstraints = (input: IParameterProperty): Record<string, unknown> | undefined => {
  return Object.entries({ ...input.constraints, required: input.required })
    .map(([name, value]) => [normalizeConstraint(name), value])
    .filter(([name]) => isNotNullOrUndefined(name))
    .reduce((acc, [name, value]) => ({ ...acc, [name as string]: value }), {});
};
